module.exports = __webpack_public_path__ + "static/media/gyandeep_logo.116fb60d.png";